package com.eladfinish.bible.contest.screens.completeVerse.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.error
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.screens.completeVerse.CompleteVerseAction
import com.eladfinish.bible.contest.screens.completeVerse.CompleteVerseState
import com.eladfinish.bible.contest.screens.completeVerse.ui.dialogs.numberPicker.NumberPickerDialog
import com.eladfinish.bible.contest.screens.mikud.ui.dialogs.SimpleMessageDialog
import com.eladfinish.bible.contest.screens.names.ui.ChapterDialog
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType.Raw
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.desc

@Composable
fun CompleteVerseDialogs(
    dialogState: CompleteVerseState.DialogState,
    onAction: (CompleteVerseAction) -> Unit,
    onNumberPicked: () -> Unit,
    onChapterDialogTitleClick: (bookIndex0: Int, chapterIndex: Int) -> Unit,
) {
    when (dialogState) {
        CompleteVerseState.DialogState.None -> Unit

        is CompleteVerseState.DialogState.Help -> {
            GeneralHelpDialog(
                titleResource = SharedRes.strings.help,
                helpContentType = Raw(dialogState.content),
                isDontShowAgainChecked = dialogState.isDontShowAgainChecked,
                onApproveDialog = {
                    onAction(CompleteVerseAction.ToggleHelp(shouldShowNextTime = it))
                },
                onDismiss = {
                    onAction(CompleteVerseAction.HideDialog)
                },
            )
        }

        is CompleteVerseState.DialogState.NumberPicker -> {
            NumberPickerDialog(
                initialNumber = dialogState.initialNumber,
                onAction = onAction,
                onNumberPicked = onNumberPicked,
            )
        }

        is CompleteVerseState.DialogState.ChapterDialog -> {
            val chapterData = dialogState.chapterData
            ChapterDialog(
                chapterData = chapterData,
                onDismiss = {
                    onAction(CompleteVerseAction.HideDialog)
                },
                onTitleClick = {
                    onAction(CompleteVerseAction.HideDialog)
                    val bookIndex0 = chapterData.bookIndex ?: return@ChapterDialog
                    val chapterIndex = chapterData.chapterIndex ?: return@ChapterDialog
                    onChapterDialogTitleClick(bookIndex0, chapterIndex)
                },
            )
        }

        is CompleteVerseState.DialogState.Error -> {
            SimpleMessageDialog(
                onDismiss = {
                    onAction(CompleteVerseAction.HideDialog)
                },
                title = SharedRes.strings.error.desc().localized(),
                content = dialogState.message,
            )
        }
    }
}
